import { ChangeEvent, FC, useCallback } from 'react';
import { useField } from 'react-final-form';

import {
  TextArea,
  TextAreaProps,
} from '@beeline/design-system-react/extracted-styles';

export interface FormTextAreaProps extends Omit<TextAreaProps, 'value'> {
  name: string;
}

export const FormTextArea: FC<FormTextAreaProps> = ({
  name,
  required,
  onChange,
  ...rest
}) => {
  const validate = useCallback(
    (value: string | undefined) => {
      if (required) {
        const trimmedValue = value?.trim();
        if (!trimmedValue) return 'Заполните поле';
      }
    },
    [required],
  );
  const { input, meta } = useField(name, { type: 'string', validate });
  const error = meta.touched ? meta.error : undefined;

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLTextAreaElement>) => {
      input.onChange(event);
      onChange?.(event);
    },
    [input, onChange],
  );

  return (
    <TextArea
      {...rest}
      {...input}
      error={!!error}
      helperText={error}
      required={required}
      onChange={handleChange}
    />
  );
};
